import { render, staticRenderFns } from "./PortTable.vue?vue&type=template&id=073e2032&scoped=true"
import script from "./PortTable.vue?vue&type=script&lang=js"
export * from "./PortTable.vue?vue&type=script&lang=js"
import style0 from "./PortTable.vue?vue&type=style&index=0&id=073e2032&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073e2032",
  null
  
)

export default component.exports